import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface MarkdownRendererProps {
  content: string;
  className?: string;
}

/**
 * Renders markdown content with proper styling.
 * Supports GitHub Flavored Markdown (tables, strikethrough, task lists, etc.)
 */
export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
  content,
  className,
}) => (
  <div
    className={`prose prose-sm dark:prose-invert max-w-none
      prose-headings:font-semibold prose-headings:text-gray-900 dark:prose-headings:text-gray-100
      prose-p:text-gray-600 dark:prose-p:text-gray-400
      prose-a:text-brand-600 prose-a:no-underline hover:prose-a:underline
      prose-strong:text-gray-900 dark:prose-strong:text-gray-100
      prose-ul:text-gray-600 dark:prose-ul:text-gray-400
      prose-ol:text-gray-600 dark:prose-ol:text-gray-400
      prose-li:marker:text-gray-400
      ${className || ""}`}
  >
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
  </div>
);
